app.factory('settingsService', function($http) {
    return {
        get: function() {
            return $http.get('/usersettings/get');
        },
        set: function(params) {
            return $http.post('/usersettings/set', params);
        },
        changepassword: function(userId, token) {
            return $http.get('/login/changepassword', {
                params: {
                    "userId": userId,
                    "token": token
                }
            });
        }
    };
});
